import produce from 'immer';
import { uploadConstants } from '../_constants';

const initialState = {
  cameraDetails: {},
  records: [],
  limitBalance: {},
  cameraByIdRecords: {},
  viewCameraRecords: [],
  vendorRecords: [],
  loading: false,
  buttonLoading: false,
  success: false,
  error: false,
  message: null,
  total: null,
  viewCameraRecordsTotal: null,
  page: 0,
  pageSize: 5,

  // payment / upload flow
  pendingFile: null,
  paymentProcessActive: false,
  cancelUploadAvailable: false,
  stripeDetails: null,
  paymentDialogError: null,
  paymentIntentLoading: false,
  paymentStatusLoading: false,
  payment_status: null,
  checkout_url: null,
  wallet_balance: 0,
  stripe_session_id: null,
};

/**
 * @param {object} state
 * @param {object} action
 */
const uploadReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    const { error, message, records, total, page, currentAvailableLimit } = action;

    switch (action.type) {
      case uploadConstants.GET_UPLOAD_HISTORY:
        draft.loading = true;
        break;
      case uploadConstants.GET_UPLOAD_HISTORY_SUCCESS:
        draft.records = records;
        draft.limitBalance = currentAvailableLimit;
        draft.loading = false;
        draft.success = true;
        draft.error = false;
        draft.message = message;
        draft.total = total;
        draft.page = page;
        break;
      case uploadConstants.GET_UPLOAD_HISTORY_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.message = message;
        break;

      case uploadConstants.GENERATE_URL:
        draft.buttonLoading = true;
        break;
      case uploadConstants.GENERATE_URL_SUCCESS:
        draft.buttonLoading = false;
        break;
      case uploadConstants.GENERATE_URL_ERROR:
        draft.buttonLoading = false;
        break;
      case uploadConstants.SET_STRIPE_SESSION_ID:
          draft.stripe_session_id = action.sessionId;
          break;        
      case uploadConstants.UPLOAD_TO_S3:
        draft.buttonLoading = true;
        break;
      case uploadConstants.UPLOAD_TO_S3_SUCCESS:
        draft.buttonLoading = false;
        break;
      case uploadConstants.UPLOAD_TO_S3_ERROR:
        draft.buttonLoading = false;
        break;

      case uploadConstants.DELETE_HISTORY:
        draft.loading = true;
        break;
      case uploadConstants.DELETE_HISTORY_SUCCESS:
        draft.loading = false;
        draft.records = records;
        draft.success = true;
        draft.error = false;
        draft.message = message;
        break;
      case uploadConstants.DELETE_HISTORY_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.message = message;
        break;

      // Payment flow local state
      case uploadConstants.SET_PAYMENT_PENDING_FILE:
        draft.pendingFile = action.file;
        break;

      case uploadConstants.CLEAR_PAYMENT_PENDING_FILE:
        draft.pendingFile = null;
        draft.paymentProcessActive = false;
        draft.cancelUploadAvailable = false;
        draft.stripeDetails = null;
        draft.paymentDialogError = null;
        draft.paymentIntentLoading = false;
        draft.paymentStatusLoading = false;
        draft.payment_status = null;
        draft.checkout_url = null;
        draft.buttonLoading = false;   // <-- add this
        break;

      case uploadConstants.SET_PAYMENT_PROCESS_ACTIVE:
        draft.paymentProcessActive = action.active;
        break;

      case uploadConstants.SET_CANCEL_UPLOAD_AVAILABLE:
        draft.cancelUploadAvailable = action.available;
        break;

      case uploadConstants.SET_PAYMENT_DIALOG_ERROR:
        draft.paymentDialogError = action.message;
        break;

      // Stripe payment intent / link
      case uploadConstants.GET_STRIPE_PAYMENT_LINK:
        draft.paymentIntentLoading = true;
        draft.paymentDialogError = null;
        draft.stripeDetails = null;
        break;

      case uploadConstants.GET_STRIPE_PAYMENT_LINK_SUCCESS:
        draft.paymentIntentLoading = false;
        draft.stripeDetails = action.stripeDetails;
        draft.checkout_url = action.stripeDetails?.checkout_url || null;
        draft.message = action.message;
        draft.error = false;
        break;

      case uploadConstants.GET_STRIPE_PAYMENT_LINK_ERROR:
        draft.paymentIntentLoading = false;
        draft.error = action.error;
        draft.message = action.message;
        draft.paymentDialogError = action.message;
        draft.stripeDetails = null;
        draft.checkout_url = null;
        break;

      // Stripe payment status
      case uploadConstants.GET_STRIPE_PAYMENT_STATUS:
        draft.paymentStatusLoading = true;
        draft.paymentDialogError = null;
        break;

      case uploadConstants.GET_STRIPE_PAYMENT_STATUS_SUCCESS:
        draft.payment_status = action.payment_status;
        draft.paymentStatusLoading = false;
        draft.error = false;
        // clear stripeDetails so we do not show "Proceed to Pay" again
        draft.stripeDetails = null;
        draft.checkout_url = null;
        break;
      case uploadConstants.SET_WALLET_PAYMENT_APPROVAL_NEEDED:
        draft.walletApprovalData = action.payload;
        draft.walletNeedsApproval = true;
        break;
        
      case uploadConstants.APPROVE_WALLET_UPLOAD:
        draft.walletNeedsApproval = false;
        draft.walletApprovalData = null;
        break;

      case uploadConstants.GET_STRIPE_PAYMENT_STATUS_ERROR:
        draft.paymentStatusLoading = false;
        draft.error = action.error;
        draft.message = action.message;
        draft.paymentDialogError = action.message || 'Payment verification failed';
        break;
      case uploadConstants.GET_WALLET_BALANCE_SUCCESS:
        draft.wallet_balance = action.wallet_balance ? Number(action.wallet_balance?.toFixed(2)) : 0;
        break;
      case uploadConstants.GET_WALLET_BALANCE_ERROR:
        draft.error = action.error;
        draft.message = action.message;
        break;  
      case uploadConstants.RESET_UPLOAD:
        draft = initialState;
        break;

      default:
        break;
    }
  });

export default uploadReducer;
